import React, { useState, useEffect, lazy, Suspense, useRef } from 'react';
import {
  Typography, Box, Container, CircularProgress, Alert, Grid, Button,
} from '@mui/material';
import EmojiEventsIcon from '@mui/icons-material/EmojiEvents';
import AddCircleOutlineIcon from '@mui/icons-material/AddCircleOutline';
import { Link as RouterLink } from 'react-router-dom';
import { getNominations } from '../services/api';
import SubmitNominationModal from '../components/SubmitNominationModal';

const NominationCard = lazy(() => import('../components/NominationCard'));

/* Ã¢â€â‚¬Ã¢â€â‚¬ Marquee ticker strip Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬ */
const ScanLineDivider = () => (
  <Box
    sx={{
      position: 'relative',
      width: '100%',
      height: 2,
      overflow: 'hidden',
      bgcolor: 'rgba(201,146,42,0.12)',
    }}
  >
    <Box
      sx={{
        position: 'absolute',
        top: 0,
        left: 0,
        width: '25%',
        height: '100%',
        background: 'linear-gradient(90deg, transparent 0%, rgba(201,146,42,0.9) 50%, transparent 100%)',
        animation: 'scanline 4s ease-in-out infinite',
        '@keyframes scanline': {
          '0%': { transform: 'translateX(-100%)' },
          '100%': { transform: 'translateX(500%)' },
        },
      }}
    />
  </Box>
);

/* Ã¢â€â‚¬Ã¢â€â‚¬ Main page Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬ */
const Home = () => {
  const [nominations, setNominations] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [submitOpen, setSubmitOpen] = useState(false);
  const nominationsRef = useRef(null);

  useEffect(() => {
    getNominations('random')
      .then(setNominations)
      .catch(() => setError('Failed to load nominations. Please try again later.'))
      .finally(() => setLoading(false));
  }, []);

  if (loading) return (
    <Box display="flex" justifyContent="center" alignItems="center" minHeight="100vh">
      <CircularProgress size={36} sx={{ color: 'primary.main' }} />
    </Box>
  );

  if (error) return (
    <Container sx={{ mt: 12 }}>
      <Alert severity="error">{error}</Alert>
    </Container>
  );

  const totalVotes = nominations.reduce((sum, n) => sum + (n.vote_count || 0), 0);

  return (
    <Box>
      {/* Ã¢â€â‚¬Ã¢â€â‚¬ Hero Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬ */}
      <Box
        sx={{
          minHeight: '100vh',
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'flex-end',
          pt: 10,
          pb: 0,
          position: 'relative',
          overflow: 'hidden',
        }}
      >
        {/* Ghost background number */}
        <Typography
          aria-hidden
          sx={{
            position: 'absolute',
            top: { xs: 50, md: 30 },
            right: { xs: -10, md: -20 },
            fontFamily: "'Bebas Neue', sans-serif",
            fontSize: { xs: '55vw', md: '25vw' },
            lineHeight: 1,
            color: 'rgba(201,146,42,0.06)',
            userSelect: 'none',
            pointerEvents: 'none',
            letterSpacing: '0.01em',
          }}
        >
          25/26
        </Typography>

        <Container maxWidth="lg">
          {/* Eyebrow */}
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5, mb: 3 }}>
            <Box sx={{ width: 28, height: 2, bgcolor: 'primary.main', borderRadius: '2px' }} />
            <Typography variant="overline" sx={{ color: 'primary.main' }}>
              25/26 Season · Now Voting
            </Typography>
          </Box>

          {/* Headline */}
          <Box sx={{ maxWidth: { md: '72%' } }}>
            <Typography
              component="h1"
              sx={{
                fontFamily: "'Bebas Neue', sans-serif",
                fontSize: { xs: '20vw', sm: '14vw', md: '11vw' },
                lineHeight: 0.88,
                letterSpacing: '0.01em',
                color: 'text.primary',
              }}
            >
              Fallon
            </Typography>
            <Typography
              component="div"
              sx={{
                fontFamily: "'Bebas Neue', sans-serif",
                fontSize: { xs: '20vw', sm: '14vw', md: '11vw' },
                lineHeight: 0.88,
                letterSpacing: '0.01em',
                color: 'primary.main',
                mb: 4,
              }}
            >
              d&apos;Floor
            </Typography>

            {/* Subtext + stats row */}
            <Box
              sx={{
                display: 'flex',
                alignItems: { xs: 'flex-start', sm: 'center' },
                flexDirection: { xs: 'column', sm: 'row' },
                gap: { xs: 3, sm: 5 },
                mb: 5,
              }}
            >
              <Typography
                variant="body1"
                sx={{ color: 'text.secondary', maxWidth: 320, lineHeight: 1.65, fontSize: '0.92rem' }}
              >
                The Ballon&nbsp;d&apos;Or&trade; for football&apos;s greatest actors.
                Vote for the most theatrical dives of the season.
              </Typography>

              <Box sx={{ display: 'flex', gap: 4, flexShrink: 0 }}>
                <Box>
                  <Typography
                    sx={{
                      fontFamily: "'Bebas Neue', sans-serif",
                      fontSize: { xs: '2.6rem', md: '3.2rem' },
                      lineHeight: 1,
                      color: 'primary.main',
                    }}
                  >
                    {nominations.length}
                  </Typography>
                  <Typography variant="overline" sx={{ color: 'text.secondary' }}>
                    Nominations
                  </Typography>
                </Box>
                <Box sx={{ width: '1px', bgcolor: 'divider' }} />
                <Box>
                  <Typography
                    sx={{
                      fontFamily: "'Bebas Neue', sans-serif",
                      fontSize: { xs: '2.6rem', md: '3.2rem' },
                      lineHeight: 1,
                      color: 'text.primary',
                    }}
                  >
                    {totalVotes.toLocaleString()}
                  </Typography>
                  <Typography variant="overline" sx={{ color: 'text.secondary' }}>
                    Votes Cast
                  </Typography>
                </Box>
              </Box>
            </Box>
          </Box>

          {/* Scroll cue */}
          <Box
            onClick={() => nominationsRef.current?.scrollIntoView({ behavior: 'smooth' })}
            sx={{
              display: 'inline-flex',
              alignItems: 'center',
              gap: 1.5,
              mb: 4,
              cursor: 'pointer',
              color: 'text.secondary',
              '&:hover': { color: 'primary.main' },
              transition: 'color 0.2s',
            }}
          >
            <Box
              sx={{
                width: 34,
                height: 34,
                borderRadius: '50%',
                border: '1.5px solid currentColor',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                fontSize: '0.9rem',
              }}
            >
              {'\u2193'}
            </Box>
            <Typography variant="overline">Cast your vote</Typography>
          </Box>
        </Container>

        <ScanLineDivider />
      </Box>

      {/* Ã¢â€â‚¬Ã¢â€â‚¬ Nominations grid Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬Ã¢â€â‚¬ */}
      <Box
        ref={nominationsRef}
        sx={{ bgcolor: '#F5F3EF', borderTop: '1px solid rgba(120,100,80,0.1)' }}
      >
        <Container maxWidth="lg" sx={{ py: { xs: 5, md: 8 } }}>
          <Box
            sx={{
              display: 'flex',
              alignItems: { xs: 'flex-start', sm: 'flex-end' },
              justifyContent: 'space-between',
              flexDirection: { xs: 'column', sm: 'row' },
              gap: 2,
              mb: 5,
              pb: 3,
              borderBottom: '1px solid rgba(120,100,80,0.12)',
            }}
          >
            <Box>
              <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5, mb: 0.5 }}>
                <Box sx={{ width: 20, height: 2, bgcolor: 'primary.main', borderRadius: '2px' }} />
                <Typography variant="overline" sx={{ color: 'text.secondary' }}>
                  All Nominations
                </Typography>
              </Box>
              <Typography variant="h4" sx={{ fontWeight: 700 }}>
                Who deserves the award?
              </Typography>
            </Box>
            <Box sx={{ display: 'flex', gap: 1.5, flexWrap: 'wrap' }}>
              <Button
                onClick={() => setSubmitOpen(true)}
                variant="contained"
                startIcon={<AddCircleOutlineIcon sx={{ fontSize: '0.95rem !important' }} />}
                sx={{
                  bgcolor: 'primary.main',
                  color: '#111',
                  fontWeight: 700,
                  fontSize: '0.8rem',
                  px: 2,
                  borderRadius: 1.5,
                  '&:hover': { bgcolor: 'primary.light' },
                }}
              >
                Submit nomination
              </Button>
              <Button
                component={RouterLink}
                to="/leaderboard"
                variant="outlined"
                startIcon={<EmojiEventsIcon sx={{ fontSize: '0.95rem !important' }} />}
                sx={{
                  borderColor: 'rgba(120,100,80,0.25)',
                  color: 'text.secondary',
                  fontSize: '0.8rem',
                  px: 2,
                  borderRadius: 1.5,
                  '&:hover': {
                    borderColor: 'primary.main',
                    color: 'primary.main',
                    bgcolor: 'rgba(201,146,42,0.06)',
                  },
                }}
              >
                View Leaderboard
              </Button>
            </Box>
          </Box>

          <Suspense
            fallback={
              <Box display="flex" justifyContent="center" py={6}>
                <CircularProgress size={32} sx={{ color: 'primary.main' }} />
              </Box>
            }
          >
            <Grid container spacing={2.5}>
              {nominations.map((nomination, idx) => (
                <Grid item key={nomination.id} xs={12} sm={6} md={4} lg={3}>
                  <NominationCard nomination={nomination} index={idx} />
                </Grid>
              ))}
            </Grid>
          </Suspense>
        </Container>
      </Box>

      <SubmitNominationModal open={submitOpen} onClose={() => setSubmitOpen(false)} />
    </Box>
  );
};

export default Home;

